<div
  class="filtering-row"
  [class.cdk-visually-hidden]="!filteringEnabled"
  appElementResize
  (elementResized)="fitToViewport && fitToViewportDirective.calculateAndSetMaxHeight()"
>
  <ng-content></ng-content>
  <div class="second-filtering-div">
    @if (hasTransientFilters) {
      <mat-icon
        class="transient-filters-info-icon"
        [matTooltip]="'transientFiltersTooltip' | translate"
        matTooltipPosition="above"
      >
        info_outline
      </mat-icon>
    }
    @if (hasActiveFilters) {
      <app-ui-button
        class="mt-0 mb-0"
        buttonType="secondary"
        text="{{ 'clearAllFilters' | translate }}"
        (click)="clearFilters()"
      ></app-ui-button>
    }
    <!-- <app-main-table-search
    [moduleName]="moduleNameForPaging"
    [totalPages]="totalPages"
    [additional]="additional"
  ></app-main-table-search> -->
    @if (searchingEnabled) {
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>{{ 'search' | translate }}</mat-label>
        <input
          class="search-field-input"
          matInput
          placeholder="{{ 'pleaseStartTypingToFilter' | translate }}"
          #input
        />
      </mat-form-field>
    }
  </div>
</div>
<div
  class="main-table-container"
  appFitToViewport
  appElementResize
  #fitToViewportDirective="fitToViewportDirective"
  [ngClass]="{
    'mat-elevation-z8': elevationEnabled,
    'default-height': fitToViewport,
  }"
  [bottomOffset]="paginationEnabled ? 57 : 2"
  [fitToViewportDisabled]="!fitToViewport"
  (elementResized)="onResize($event); fitToViewportDirective.calculateAndSetMaxHeight()"
>
  <table
    mat-table
    matSort
    [dataSource]="dataSource"
    class="main-table-container"
    multiTemplateDataRows
    (matSortChange)="sortData($event)"
  >
    @if (showSelector) {
      <ng-container matColumnDef="multiselect">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="$event ? toggleAllRows() : null"
            [checked]="multipleSelection.hasValue() && isAllSelected()"
            [indeterminate]="multipleSelection.hasValue() && !isAllSelected()"
            [aria-label]="checkboxLabel()"
          ></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            [class.cdk-visually-hidden]="hideDisabledCheckbox && row[disableSelectionByColumn]"
            [disabled]="row[disableSelectionByColumn]"
            (change)="$event ? toggleSingle(row) : null"
            (click)="$event.stopPropagation()"
            [indeterminate]="isSomeRowsInGroupSelected(row) && !isAllRowsInGroupSelected(row)"
            [checked]="multipleSelection.isSelected(row)"
            [aria-label]="checkboxLabel(row)"
          ></mat-checkbox>
          @if (hideDisabledCheckbox && row[disableSelectionByColumn]) {
            <mat-icon class="ml-05" [matTooltip]="disabledCheckboxIconTooltip">
              {{ disabledCheckboxIcon }}
            </mat-icon>
          }
        </td>
      </ng-container>
    }
    @for (columnName of columnDefinitions; track $index) {
      <ng-container [matColumnDef]="columnName">
        @if (filterConfig?.[columnName]) {
          <th
            mat-header-cell
            *matHeaderCellDef
            [ngClass]="{
              'border-panel-top': columnPanelMap[columnName]?.inPanel,
              'in-panel': columnPanelMap[columnName]?.inPanel,
              'border-panel-right':
                columnPanelMap[columnName]?.endIndex === $index &&
                columnPanelMap[columnName]?.inPanel,
              'border-panel-left':
                columnPanelMap[columnName]?.startIndex === $index &&
                columnPanelMap[columnName]?.inPanel,
            }"
          >
            @if (columnName | shouldHeaderBeDisplayed) {
              <button
                class="column-filter-button"
                [matMenuTriggerFor]="menu"
                #trigger="matMenuTrigger"
                appStopClickPropagation
              >
                {{ columnTitlesMap[columnName] || columnName | translate | titlecase }}
                @if (
                  (orderByColumn | lowercase) ===
                  (getProperHeaderNameForAPI(columnName, moduleName) | lowercase)
                ) {
                  @if (sortDirection) {
                    <mat-icon class="active">
                      {{ sortDirection === 'Ascending' ? 'arrow_upward' : 'arrow_downward' }}
                    </mat-icon>
                  }
                }
                <mat-icon [class.active]="columnFilter.hasActiveFilters">filter_list</mat-icon>
              </button>
              <mat-menu
                #menu="matMenu"
                class="column-filter-menu"
                (closed)="columnFilter.initControlsFromInitialFilters()"
              >
                <app-main-table-column-filter
                  #columnFilter="appMainTableColumnFilter"
                  [initialFilters]="columnFilters[columnName] ?? []"
                  [column]="columnName"
                  [filterConfig]="filterConfig ?? {}"
                  [sortDirection]="
                    (orderByColumn | lowercase) ===
                    (getProperHeaderNameForAPI(columnName, moduleName) | lowercase)
                      ? (sortDirection ?? '')
                      : ''
                  "
                  [sorting]="sortingEnabled && !(disabledColumnHeaders | contains: columnName)"
                  (close)="trigger.closeMenu()"
                  (sort)="sortData($event)"
                  (filter)="applyColumnFilters(columnName, $event)"
                ></app-main-table-column-filter>
              </mat-menu>
            }
          </th>
        } @else {
          <th
            mat-header-cell
            *matHeaderCellDef
            [mat-sort-header]="columnName"
            sortActionDescription="{{ 'sortBy' | translate }} {{ columnName }}"
            [ngClass]="{
              'expand-column': columnName === 'expand',
              'in-panel': columnPanelMap[columnName]?.inPanel,
              'border-panel-top': columnPanelMap[columnName]?.inPanel,
              'border-panel-right':
                columnPanelMap[columnName]?.endIndex === $index &&
                columnPanelMap[columnName]?.inPanel,
              'border-panel-left':
                columnPanelMap[columnName]?.startIndex === $index &&
                columnPanelMap[columnName]?.inPanel,
            }"
            [disabled]="disabledColumnHeaders | contains: columnName"
          >
            @if (columnName | shouldHeaderBeDisplayed) {
              {{ columnTitlesMap[columnName] || columnName | translate | uppercase }}
            }
          </th>
        }
        <td
          mat-cell
          *matCellDef="let element; let i = dataIndex"
          [ngClass]="{
            'expired-due-list': element.status === 'Expired',
            'expiring-due-list': element.status === 'Expiring',
            'in-panel': columnPanelMap[columnName]?.inPanel,
            'border-panel-right':
              columnPanelMap[columnName]?.endIndex === $index &&
              columnPanelMap[columnName]?.inPanel,
            'border-panel-left':
              columnPanelMap[columnName]?.startIndex === $index &&
              columnPanelMap[columnName]?.inPanel,
            'pointer-cursor': clickableColumns.includes(columnName),
            'main-table-column-hover-accent': !!columnHoverTooltips[columnName],
          }"
          [matTooltip]="
            columnHoverTooltips[columnName] ? (columnHoverTooltips[columnName] | translate) : ''
          "
          [matTooltipPosition]="columnHoverTooltips[columnName] ? 'left' : 'below'"
          [matTooltipDisabled]="!columnHoverTooltips[columnName]"
        >
          @if (element | isArray) {
            <a mat-button>
              @for (singleElement of element.columnName; track $index) {
                <div>
                  {{ singleElement }}
                </div>
              }
            </a>
          } @else {
            @if (columnName === 'expand') {
              @if (expandedElement !== element) {
                <mat-icon>keyboard_arrow_right</mat-icon>
              }
              @if (expandedElement === element) {
                <mat-icon>keyboard_arrow_down</mat-icon>
              }
            } @else {
              <app-main-table-module-specific-template
                [module]="moduleName"
                [columnName]="columnName"
                [element]="element"
                [urlForRouting]="urlForRow"
                [specificTemplateName]="specificTemplateName"
                [buttonFunctions]="buttonFunctions | passArgumentsToObjFunctions: i"
                [hideButtons]="hideButtons"
                (click)="handleColumnClick($event, columnName, element)"
              ></app-main-table-module-specific-template>
            }
          }
        </td>
      </ng-container>
    }

    <ng-container matColumnDef="subHeader">
      <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
        {{ !!element['address']?.subscribe ? (element['address'] | async) : element['address'] }}
      </td>
    </ng-container>

    <ng-container matColumnDef="maintenanceJobsGroupName">
      <td
        mat-cell
        *matCellDef="let element"
        [attr.colspan]="displayedColumns.length"
        class="maintenance-job-subheader-column"
      >
        <div class="maintenancce-job-shubheader-container">
          <span class="maintenance-job-group-name" [attr.title]="element.name">
            {{ element.name }}
          </span>

          <span class="sub-header-badge">{{ element.expiredJobsCount }}</span>
          <span class="sub-header-attributes">
            @if (element.isCriticalComponent) {
              <mat-icon [matTooltip]="'criticalComponent' | translate">warning</mat-icon>
            }
            @if (element.isE0Component) {
              <mat-icon [matTooltip]="'E0Component' | translate">visibility</mat-icon>
            }
            @if (element.isClassComponent && !!element.classId) {
              <mat-icon [matTooltip]="('classId' | translate) + ': ' + element.classId">
                health_and_safety
              </mat-icon>
            }
          </span>
        </div>
      </td>
    </ng-container>

    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
      <td
        mat-cell
        *matCellDef="let element"
        [attr.colspan]="displayedColumns.length"
        class="no-padding"
      >
        @if (
          needExpandableRowLoader &&
          element === expandedElement &&
          (expandableRowLoadingActions | actionInProgress: true | async) === true
        ) {
          <div class="loader" *appLoader="true"></div>
        }
        @if (isExpandable && element === expandedElement) {
          <div class="element-detail">
            <app-main-table-expandable-row
              [class.cdk-visually-hidden]="
                needExpandableRowLoader &&
                (expandableRowLoadingActions | actionInProgress: true | async) === true
              "
              [displayedColumns]="displayedColumns"
              [detailsDisplayedColumns]="detailsDisplayedColumns"
              [specificTemplateName]="specificTemplateName"
              [moduleName]="moduleName"
              [parentRow]="element"
              [urlForRow]="urlForRow"
              [disabledColumnHeaders]="disabledColumnHeaders"
              [clickableColumns]="clickableColumns"
              [columnTitlesMap]="columnTitlesMap"
              [tableData]="runTimeChildElements()"
              (columnHandler)="handleChildColumnClick($event)"
            ></app-main-table-expandable-row>
          </div>
        }
      </td>
    </ng-container>

    @if (showHeaders) {
      <ng-container *matHeaderRowDef="displayedColumns">
        @if (panelConfig) {
          <tr class="panel-headers">
            @for (panel of panelConfig; track panel) {
              <td [attr.colspan]="panel.length" class="panel-header" [class.filled]="!!panel.title">
                {{ panel.title }}
              </td>
            }
          </tr>
        }
        <tr mat-header-row></tr>
      </ng-container>
    }
    <tr
      *matRowDef="let row; columns: displayedColumns"
      mat-row
      [class.cdk-visually-hidden]="row.isSubHeader"
      [class.pointer-cursor]="
        !rowClickDisabled && (urlForRow.length > 1 || rowHandler.observers.length > 0)
      "
      [class.expanded-row]="expandedElement === row"
      [ngClass]="[trClass || '', trClassMap[row[idFieldNameForRowHandler] || row.id] || '']"
      (click)="handleRowClick(row)"
    ></tr>
    <tr
      *matRowDef="let row; columns: ['expandedDetail']"
      [class.cdk-visually-hidden]="row.isSubHeader || !isExpandable"
      mat-row
      class="detail-row"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: maintenanceSubheaderColumns"
      [class.cdk-visually-hidden]="!row.isMaintenanceJobGroup"
      class="subheader-row subheader-maintenance-job-group"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: ['subHeader']"
      [class.cdk-visually-hidden]="!row.isSubHeader || row.isMaintenanceJobGroup"
      class="subheader-row"
    ></tr>
    <!-- Row shown when there is no matching data. -->
    @if (filteringEnabled) {
      <div>
        <tr class="mat-row" *matNoDataRow>
          @if (filterValue) {
            <td class="mat-cell" colspan="4">
              {{ 'noDataMatchingTheFilter' | translate }} "{{ filterValue }}"
            </td>
          }
          @if (!filterValue) {
            <td class="mat-cell" colspan="4">
              {{ 'thereIsCurrentlyNoDataInTheTable' | translate }}
            </td>
          }
        </tr>
      </div>
    }
  </table>
  @if (paginationEnabled) {
    <app-main-table-paginator
      aria-label="Select page of items"
      class="paginator"
      [moduleName]="moduleNameForPaging"
      [totalPages]="totalPages"
      [additional]="additional"
      [showPageSizeSelector]="showPageSizeSelector"
      [initialPageSize]="defaultInitialPageSize"
      [skipInitialLoad]="skipInitialLoad"
      [initialFilters]="initialFilters"
      [ngClass]="{
        'main-table-paginator': viewMode === 'full',
      }"
    ></app-main-table-paginator>
  }
</div>
@if (loading) {
  <div class="loader" *appLoader="true"></div>
}
